export const getMonteCarloTourSteps = () => [
  {
    target: '[data-tour="monte-carlo-parameters"]',
    content: 'This is where you configure your Monte Carlo simulation parameters. You can adjust the starting corpus, income, expenses, and target corpus.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="monte-carlo-scenario"]',
    content: 'Choose your market scenario - Base, High Inflation, or Low Return. Each scenario has different return and inflation assumptions.',
    placement: 'right',
  },
  {
    target: '[data-tour="monte-carlo-save"]',
    content: 'Save your current settings to persist them across sessions. Your preferences will be remembered for next time.',
    placement: 'top',
  },
  {
    target: '[data-tour="monte-carlo-kpis"]',
    content: 'View your simulation results here. Success probability shows how often you reach your target, while percentiles show the range of possible outcomes.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="monte-carlo-trajectories"]',
    content: 'This chart shows sample run trajectories, giving you a visual sense of how your wealth might grow over time under different market conditions.',
    placement: 'top',
  },
  {
    target: '[data-tour="monte-carlo-average"]',
    content: 'The average corpus chart shows the expected growth path based on your parameters, helping you understand the typical outcome.',
    placement: 'top',
  },
  {
    target: '[data-tour="monte-carlo-histogram"]',
    content: 'This histogram shows the distribution of final corpus values across all simulation runs, helping you understand the range of possible outcomes.',
    placement: 'top',
  },
];
